import { useState } from "react";
import { useTranslation } from "react-i18next";
import { OcCardButtonBarProps } from "../card-button-bar";
import { useOcIsMobile } from "oc/hooks";

interface UseOcRoleFilterProps {
  buttonBarProps?: Partial<OcCardButtonBarProps>;
  defaultOpened?: boolean;
  innerWidth?: string;
  noFilters?: boolean;
}

export const useOcRoleFilter = ({
  buttonBarProps,
  defaultOpened,
  innerWidth,
  noFilters,
}: UseOcRoleFilterProps) => {
  const { t } = useTranslation();
  const isMobile = useOcIsMobile();
  const [opened, setOpened] = useState(defaultOpened ?? false);

  let returnInnerWidth = innerWidth ?? "";
  if (!innerWidth) {
    // If innerWidth isn't given, have this as a "default" value.
    returnInnerWidth = isMobile ? "100%" : "66%";
  }

  const cardButtonBarPropsWithDefaults: OcCardButtonBarProps = {
    // This way, if we only add handlers for the buttons,
    // the other parts of the code don't have to be set.
    noLine: true,
    rightButtonText: t("OC_RESET"),
    rightButtonId: "cancel-button",
    rightButtonColor: "secondary",
    primaryButtonText: t("OC_FILTERING"),
    primaryButtonId: "filter-button",
    ...buttonBarProps,
  };

  const handleOpenHeader = () => {
    setOpened(!opened);
  };

  let containerPadding: string | undefined = "32px 0px 26px";

  if (noFilters) {
    if (isMobile) containerPadding = undefined;
    else containerPadding = "22px 0px 38px";
  } else {
    if (isMobile) {
      containerPadding = "32px 0px 10px";
    }
  }

  return {
    cardButtonBarPropsWithDefaults,
    handleOpenHeader,
    opened,
    innerWidth: returnInnerWidth,
    containerPadding,
  };
};
